export default __webpack_public_path__ + "static/media/wehavemoved.587f70ac.jpg";